
	keyboardControl = function (e) {
		var currentItem = jQuery(this);
		var currentItemKeyControl = currentItem.data("keyControl");

		// handle relevent key press if the item has functionality for that key
		switch(e.which) {
			case 40: // arrow down
				if( jQuery.isFunction(currentItemKeyControl.down)) { currentItemKeyControl.down(e, currentItem) };
			break;

			case 38: // arrow up
				if( jQuery.isFunction(currentItemKeyControl.up)) { currentItemKeyControl.up(e, currentItem) };
			break;

			case 9: // tab
				if( jQuery.isFunction(currentItemKeyControl.tab)) { currentItemKeyControl.tab(e, currentItem); };
			break;

			case 13: // enter
				if( jQuery.isFunction(currentItemKeyControl.enter)) { currentItemKeyControl.enter(e, currentItem) };
			break;

			case 27: // esc
				if( jQuery.isFunction(currentItemKeyControl.esc)) { currentItemKeyControl.esc(e, currentItem) };
			break;

			default:

			break;
		}

		return;
	};

	// use keyboard navigation
	jQuery("#main-navigation > li:not(.home) > a").data("keyControl", {
		tab: function(e, $this) {
			// functionality for matched elements here
			// run if shift button isn't pressed - if it is, default behaviour is good
			if(!e.shiftKey) {
				var nextItem = $this.parent().next("li").find("> a");

				if(nextItem.length === 0) {
					nextItem = $this.parent().parent().next("ul").find("li > a");
				}

				e.preventDefault();
				nextItem.focus();
			}

		},
		down: function(e, $this) {
			e.preventDefault();
			// functionality for matched elements here
			$this.parent().addClass("active");
			// goto child menu
			var childItem = $this.parent().find(".mega-menu li a").first();
			if(childItem.length > 0) {
				e.preventDefault();
				childItem.focus();
			}

		}
	}).keydown(keyboardControl);

	// add active class to the current focussed item to open mega menu
	jQuery("#main-navigation > li:not(.home) > a").focusin(function(e){
		jQuery(this).parent().parent().find("li").removeClass("active");
		// jQuery(this).parent().parent().find("li.expandable").attr('aria-expanded', 'false');

		var $listItem = jQuery(this).parent();
		$listItem.addClass("active");

		// if this item has sub items, mark it as expanded for accessibility
		if($listItem.hasClass("expandable")) {
			// $listItem.attr('aria-expanded', 'true');
		}
	});

	// hide the keyboard activated nav when other elements are in focus
	jQuery("li.home a, ul.right a, .search-form input").focusin(function(e){
		jQuery("#main-navigation > li").removeClass("active");
		if(jQuery("#main-navigation > li.expandable").attr('aria-expanded')) {
			jQuery("#main-navigation > li.expandable").attr('aria-expanded', 'false');
		}

	});
/*
	jQuery("#main-navigation > li").last().find("> a").focusout(function(e){
		//jQuery(this).parent().parent().find("li").removeClass("active");
	});
*/
	// 	main nav child items
	jQuery(".mega-menu li a").data("keyControl", {
		down: function(e, $this) {
			// go to next item
			e.preventDefault();

			// next item

			// if item has children, cycle through those first (currently disabled, not showing lower level trees in menu)
			// var nextItem = $this.parent().find("ul.children li a").first();

			// if no child items, get next same level item (sibling)
			// if(nextItem.length < 1) {
				var nextItem = $this.parent().next("li").find("> a");
			// }

			// if no siblings check if the parent has siblings
			if(nextItem.length < 1) {
				nextItem = $this.parent().parent().parent().next("li").find("> a");
			}

			// if no next sibling item either, see if theres another list (column) after this one (cousin?)
			if(nextItem.length < 1) {
				nextItem = $this.parent().parent().next("ul").find("li a").first();
			}

			// check again for another list but in the context of moving from a child item of another item
			if(nextItem.length < 1) {
				nextItem = $this.parentsUntil(".mega-menu").next("ul").find("li a").first();
			}

			if(nextItem.length > 0) {
				e.preventDefault();
				nextItem.focus();
			} else {
				// dont seem to be any more items, go back to main link
				$this.parentsUntil(".mega-menu").parent().parent().find("a").first().focus();

				return;
			}
		},
		up: function(e, $this) {
			e.preventDefault();
			// previous item
			var prevItem = $this.parent().prev("li").find("a");
			if(prevItem.length > 0) {
				e.preventDefault();
				prevItem.focus();
			}

			return;
		},
		tab: function(e, $this) {
			// go to next main nav item
			jQuery("#main-navigation > li").removeClass("active");
			$this.parentsUntil(".mega-menu").parent().next("li").focus();

			return;
		},
		esc: function(e, $this) {
			// go to this sections main nav item
			$this.parentsUntil(".mega-menu").parent().prev().focus();
			return;
		}
	}).keydown(keyboardControl);
